import { AxiosError } from "axios";

export type HelpContent = {
  id: string;
  slug: string;
  title: string;
  metadata: {
    content: string;
    tag: Tag[];
    product: Product;
    parent?: HelpContent;
  };
};

export type Category = {
  id: string;
  slug: string;
  title: string;
  metadata: {
    children: HelpContent[];
    description?: string;
    /**
     * 記事詳細ページのナビゲーションにも表示するかどうか
     *
     * CosmicJSのkeyに合わせているため、命名規則に従っていない
     */
    isvisibleinnavigation: boolean;
  };
};

export class CosmicJSError extends Error {
  code: string;
  error: Error;

  constructor({ error, code }: { error: Error | AxiosError; code: string }) {
    super(error.message);
    this.name = "CosmicJS Error";
    this.code = code;
    this.error = error;
  }

  static isCosmicJSError(error: Error): error is CosmicJSError {
    return error instanceof CosmicJSError;
  }
}

export type Tag = {
  id: string;
  slug: string;
  title: string;
};

export type Product = {
  id: string;
  slug: string;
  title: string;
};
